export default "__VITE_ASSET__DlWm84Ku__"